export default {
  headerContent: {
    title: 'Ray Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Ray Sigorta Konut Sigortası',
    description: {
      title: 'Ray Sigorta Konut Sigortası (Ev Sigortası) Nedir? ',
      content: [
        'Ray Sigorta’nın sunmuş olduğu Evimsaray Konut Sigortası ile konutunuzda olması muhtemel hasarlara karşı koruma sağlayabilirsiniz.',
        'Eminsaray Konut Sigortası sadece yangın, sel ve su baskını hasarları değil birçok hasara karşı güvence sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Ray Sigorta Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: 'Konut sigortası teminatları:',
          subList: [
            'Yangın',
            'Sel, Su Baskını',
            'Fırtına',
            'Kara Taşıtları Çarpması',
            'Hava Taşıtları Çarpması',
            'Deniz Taşıtları Çarpması',
            'Dumanın Vereceği Zararlar',
            'Yer Kayması',
            'Grev, Lokavt, Kargaşalık, Halk Hareketleri, Kötü Niyetli Hareketler',
            'Terör',
            'Kar Ağırlığı',
            'Cam Kırılması',
            'Enkaz Kaldırma Giderleri',
            'Hırsızlık',
            'Hasar Nedeniyle Yapılacak İkametgah Değişikliği Masrafları',
            'Ferdi Kaza',
            'Kişisel Üçüncü Şahıs Mali Sorumluluk',
            'Yangın - İnfilak Mali Sorumluluk',
            'Kira Kaybı Ve Kullanım Mahrumiyeti',
            'Elektrik Hasarları',
            'Dolu Teminatı',
            'Yakıt Sızması Teminatı',
            'Sabit Elektronik Cihazlar İçin Elektronik Cihaz Teminatı',
            'İzolasyon Teminatı'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Ray Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
